import * as React from 'react';

interface ContainerProps {
  className?: string;
  children: JSX.Element | JSX.Element[];
  overflowHidden?: boolean;
}

interface ColumnProps {
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
  className?: string;
  children: React.ReactNode;
}

interface GridProps {
  isFlush?: boolean;
  className?: string;
}

export const Container = ({
  children,
  className,
  overflowHidden = false,
}: ContainerProps) => (
  <div className={`container ${overflowHidden && 'container--overflow-hidden'} ${className}`}>
    {children}
  </div>
);

const Column = ({
  sm = 6,
  md = 6,
  lg = 12,
  xl,
  className,
  children,
}: ColumnProps) => (
  <div className={`column col-sm-${sm} col-md-${md} col-lg-${lg} ${xl && `col-xl-${xl}`} ${className}`}>
    {children}
  </div>
);

export class Grid extends React.Component<GridProps> {
  static container = Container;

  static Column = Column;

  render() {
    const {
      children,
      isFlush,
      className,
    } = this.props;
    return (
      <div className={`grid ${isFlush && 'grid--flush'} ${className}`}>
        {children}
      </div>
    );
  }
}
